/**
 * @author yeshengsheng
 *
 * storageDataCache
 * 系统中本地 localStorage&sessionStorage 缓存维护
 *
 * How to use?
 * Please follow the steps below:
 * 1 step
 * 2 step
 * 3 step
 * ...
 */

import { getUserInfo } from '@/utils/auth'
import { isJsonObj, isArray } from '@/utils/validate'

const localStorage = window.localStorage
const localStoragePrefix = `localStorage_cache__$$tenantId_${getUserInfo().tenantId}$$_`

/** 1 step: description constants for module,Need to be guaranteed unique ***/
// 业务模块
const MODULE_JOB_SE = 'job_Se_'
const MODULE_CONFIGURATION = 'configuration' // LocalConfigManager

/** 2 step: description key of storage***/
export const LOCAL_STORE_KEY_JOB_SE_FILEHISTORY = `${localStoragePrefix}${MODULE_JOB_SE}_fileHistory_`
export const LOCAL_STORE_KEY_CONFIGURATION = `${localStoragePrefix}${MODULE_CONFIGURATION}_config_`

/** 3 step: config key of storage ,key and value are the same ***/
const storageCacheConfig = {
  [LOCAL_STORE_KEY_JOB_SE_FILEHISTORY]: LOCAL_STORE_KEY_JOB_SE_FILEHISTORY,
  [LOCAL_STORE_KEY_CONFIGURATION]: LOCAL_STORE_KEY_CONFIGURATION
}

export function getConfigKey() {
  return `localStorage_cache__$$tenantId_${getUserInfo().tenantId}$$_configuration_config_`
}

export function hasKey(key, byUser = false) {
  if (byUser) {
    key = getKey(key, byUser)
  }
  // return !!storageCacheConfig[key]
  return !!localStorage.getItem(key)
}

function getKey(key, byUser) {
  if (byUser) {
    key = `${key}_$$userId_${getUserInfo().userId}$$`
  }
  return key
}

/**
 * 根据key获取 LocalStorageCache
 * @param key
 * @param byUser 是否为当前用户缓存
 * @returns {string|*}
 */
export function getLocalStorageCache(key, byUser = false, tryConvertJson = true) {
  let result = ''
  key = getKey(key, byUser)
  if (!hasKey(key)) { return result }
  result = localStorage.getItem(key)
  // console.log('setLocalStorageCache', key + '===' + result)
  if (result && tryConvertJson) {
    try {
      // 先尝试转json
      result = JSON.parse(result)
    } catch (err) {
      return result
    }
  }
  return result
}
/**
 * 根据key设置 LocalStorageCache
 * @param key
 * @param value
 * @param byUser 是否为当前用户缓存
 */
export function setLocalStorageCache(key, value, byUser = false) {
  key = getKey(key, byUser)
  if (isJsonObj(value) || isArray(value)) {
    localStorage.setItem(key, JSON.stringify(value))
  } else {
    // 全部作为 字符串对待
    localStorage.setItem(key, value)
  }
  // console.log('setLocalStorageCache', key + '===' + value)
}
/**
 * 根据key移除 LocalStorageCache
 * @param key
 * @param byUser 是否为当前用户缓存
 */
export function removeLocalStorageCache(key, byUser = false) {
  key = getKey(key, byUser)
  return !!localStorage.removeItem(key)
}

/**
 * 清除某一范围 or 某一个用户的缓存数据
 * @param module #see
 * @param byUser
 * @param ruleRelation 移除规则[module和byUser的关系]
 */
export function clearModuleOrUserLocalStorageCache(module, byUser = false, ruleRelation = 'AND') {
  const localStorageKeys = Object.keys(localStorage)
  const rulePrefix = module ? `localStorage_cache__$$tenantId_${getUserInfo().tenantId}$$_${module}` : ''
  const ruleSuffix = byUser ? `_$$userId_${getUserInfo().userId}$$` : ''

  if (!['AND', 'OR'].includes(ruleRelation)) {
    console.error('error occurred when call 【clearModuleOrUserLocalStorageCache】,because the ruleRelation is error：please set 【AND】 or 【OR】')
    return
  }
  if (!rulePrefix && !ruleSuffix) {
    // all empty
    console.error('error occurred when call 【clearModuleOrUserLocalStorageCache】,because module and byUser are empty')
    return
  }
  localStorageKeys.forEach(key => {
    if (ruleRelation === 'AND') {
      if (key.startsWith(rulePrefix) && key.endsWith(ruleSuffix)) {
        localStorage.removeItem(key)
      }
    } else {
      if ((rulePrefix && key.startsWith(rulePrefix)) || (ruleSuffix && key.endsWith(ruleSuffix))) {
        localStorage.removeItem(key)
      }
    }
  })
}

/**
 * 清除全部缓存，慎用
 */
export function clearAllLocalStorageCache() {
  localStorage.clear()
}
